
export const fieldsConfig = [
  {
    name: "designation_name",
    label: "Designation Name",
    type: "text",
    required: true,
  },
  {
    name: "designation_code",
    label: "Designation Code",
    type: "text",
    required: true
  },
  

];